import { Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

const PREFIX = "PermanentInput";
export const classes = {
  root: `${PREFIX}-root`,
  duration: `${PREFIX}-duration`,
  unit: `${PREFIX}-unit`,
};

export const ContractDurationStack = styled(Stack)(({ theme }) => ({
  [`&.${classes.root}`]: {
    flexWrap: "nowrap",
    flexDirection: "row",
    gap: theme.spacing(1),
  },

  [`& .${classes.duration}`]: {
    flexBasis: "50%",
  },
  [`& .${classes.unit}`]: {
    flexBasis: "50%",
  },
}));
